var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"root",staticClass:"googleSearchResultRoot"},[_c('GoogleSearch',{staticClass:"searchBar",attrs:{"defaultSearchTerm":_vm.searchTerm,"addSearchLabel":true},on:{"change":_vm.onChange}}),_c('div',{staticClass:"gcse-searchresults-only",attrs:{"data-gname":"searchResult"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }